var version = {
    "name":      "dativery",
    "buildDateCode": "20260225-150215",
    "buildDate": "Wed Feb 25 2026 15:02:15 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260225-150215",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;